import { render, staticRenderFns } from "./CChat.vue?vue&type=template&id=3a9e4e93&scoped=true"
import script from "./CChat.vue?vue&type=script&lang=js"
export * from "./CChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9e4e93",
  null
  
)

export default component.exports